import { Routes } from '@angular/router';
import { LandingLayoutComponent } from './core/components/landing-layout/landing-layout.component';
import { MainLayoutComponent } from './core/components/main-layout/main-layout.component';
import { authGuard, noAuthGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';

export const routes: Routes = [
  {
    path: '',
    component: LandingLayoutComponent,
    canActivate: [noAuthGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/landing/landing-page/landing-page.component').then(c => c.LandingPageComponent)
      }
    ]
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'admin',
        canActivate: [adminGuard],
        loadComponent: () =>
          import('./features/admin/admin-dashboard/admin-dashboard.component').then(c => c.AdminDashboardComponent)
      },
      {
        path: 'projects',
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./features/project/project-list/project-list.component').then(c => c.ProjectListComponent)
          },
          {
            path: ':id',
            loadComponent: () =>
              import('./features/results/results-page/results-page.component').then(c => c.ResultsPageComponent)
          }
        ]
      }
    ]
  },
  {
    path: 'export/:id',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/results/results-export/results-export.component').then(c => c.ResultsExportComponent)
  },
  {
    path: '**',
    redirectTo: ''
  }
];
